import axios from 'axios'
// import store from '@/store'
import router from '@/router'
import { Message } from 'view-design'
import util from '@/libs/util'
import $config from '@/config'
import JSONbig from 'json-bigint'
const { apiUrl } = $config
const TIME_OUT_MAX = 10000
const ACCEPT_EXPORT = 'application/vnd.ms-excel'

const Axios = axios.create({
  baseURL: apiUrl,
  timeout: TIME_OUT_MAX,
  // responseType: 'json', // 注释了再使用JSONbig
  withCredentials: true // 是否允许带cookie这些
})

// 11/2 处理js的整数精度丢失(整数有安全范围，即:最大能显示的范围，超过了这个范围可能会数据精度丢失)
Axios.defaults.transformResponse = [function (data) {
  try {
    try {
      return JSONbig.parse(data)
    } catch (e) {
      return JSON.parse(data)
    }
  } catch (_e) {
    return data
  }
}]
Axios.interceptors.request.use(
  config => {
    if (config.url === '/admin/xcx/preview' || config.url === '/admin/xcx/publish' || config.url === '/admin/xcx/openAndConf' || config.url === '/admin/xcx/login') {
      config.timeout = 120000
    }
    if (config.method.toLocaleLowerCase() === 'get') {
      config.params = JSON.parse(JSON.stringify(config.data))
      config.data = {}
    } else {
      if (config.data.formparam) {
        config.headers = {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
        var params = new URLSearchParams()
        for (let key in config.data) {
          if (key !== 'formparam') {
            params.append(key, config.data[key])
          }
        }
        config.data = params
      } else {
        config.headers = {
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }
    }
    // 5/28,是否下载
    if (config.url.indexOf('/export') > 0) {
      config.headers.Accept = ACCEPT_EXPORT
      config.responseType = 'blob'
    }
    const token = util.cookies.get('token')
    if (token) {
      config.headers.Authorization = 'Bearer ' + token
    }
    return config
  },
  error => {
    Message.error({
      showClose: true,
      content: error && error.data.error.message,
      duration: 3
    })
    return Promise.reject(error.data.error.message)
  }
)

// 处理bolb数据
const blobHandle = async (data) => {
  return new Promise((resolve, reject) => {
    if (data.type !== ACCEPT_EXPORT) {
      try {
        let reader = new FileReader()
        reader.readAsText(data)
        reader.onload = function (evt) {
          let data = evt.target.result
          let pasteData = data.trim()
          reject(JSON.parse(pasteData))
        }
      } catch (error) {
        reject(error)
      }
    } else {
      const url = window.URL.createObjectURL(new Blob([data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', new Date().toLocaleDateString().replace('/', '-') + '.xls')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      resolve()
    }
  })
}

Axios.interceptors.response.use(
  response => {
    if (response.config.responseType === 'blob') {
      return blobHandle(response.data)
    }
    const dataAxios = response.data
    const {
      code,
      message
    } = dataAxios
    // 根据 code 进行判断
    if (code === 200) {
      return Promise.resolve(dataAxios)
    } else {
      if (code === 403 && message === '未登录') {
        util.cookies.remove('token')
        router.push({ name: 'Login' })
      }
      return Promise.reject(dataAxios)
    }
  },
  error => {
    if (error && error.response) {
      switch (error.response.status) {
        case 400:
          error.message = '请求错误'
          break
        case 401:
          error.message = '未授权，请登录'
          break
        case 403:
          error.message = '拒绝访问'
          break
        case 404:
          error.message = `请求地址出错: ${error.response.config.url}`
          break
        case 408:
          error.message = '请求超时'
          break
        case 500:
          error.message = '服务器内部错误'
          break
        case 501:
          error.message = '服务未实现'
          break
        case 502:
          error.message = '网关错误'
          break
        case 503:
          error.message = '服务不可用'
          break
        case 504:
          error.message = '网关超时'
          break
        default:
          break
      }
    }
    return Promise.reject(error)
  }
)
export default Axios



// WEBPACK FOOTER //
// ./src/axios/axios.js